export const IconEmail = () => (
  <svg
    className="contact__icon"
    width="18"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="contact__icon__stroke"
      d="M13.39 5.551L9.835 8.413a1.853 1.853 0 01-2.288 0L3.962 5.55"
      stroke="#979797"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="contact__icon__stroke"
      clipRule="evenodd"
      d="M4.74.917h7.857a4.13 4.13 0 012.983 1.325 4.18 4.18 0 011.105 3.086v5.44a4.18 4.18 0 01-1.105 3.087 4.13 4.13 0 01-2.983 1.325H4.74c-2.433 0-4.073-1.98-4.073-4.412v-5.44C.667 2.896 2.307.917 4.74.917z"
      stroke="#979797"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const IconEye = () => (
  <svg
    className="contact__icon"
    width="18"
    height="14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="contact__icon__stroke"
      clipRule="evenodd"
      d="M11.634 7.044a2.635 2.635 0 11-5.269 0 2.635 2.635 0 015.27 0z"
      stroke="#979797"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="contact__icon__stroke"
      clipRule="evenodd"
      d="M8.998 13.13c3.174 0 6.076-2.283 7.71-6.086C15.074 3.241 12.172.96 8.998.96h.004c-3.174 0-6.076 2.282-7.71 6.085 1.634 3.803 4.536 6.085 7.71 6.085h-.004z"
      stroke="#979797"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const IconUser = () => (
  <svg
    className="contact__icon"
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      className="contact__icon__stroke"
      cx="9.649"
      cy="6.065"
      stroke="#979797"
      strokeLinecap="round"
      strokeLinejoin="round"
      r="3.982"
    />
    <path
      className="contact__icon__stroke"
      clipRule="evenodd"
      d="M3.333 15.584c0-.28.062-.556.183-.808.382-.763 1.457-1.167 2.35-1.35.643-.138 1.296-.23 1.953-.275a20.873 20.873 0 013.653 0c.657.046 1.31.138 1.953.275.892.183 1.968.549 2.35 1.35.244.514.244 1.11 0 1.625-.382.8-1.458 1.167-2.35 1.342a13 13 0 01-1.953.282c-.99.084-1.983.1-2.975.046-.228 0-.45 0-.678-.046a12.852 12.852 0 01-1.946-.282c-.9-.175-1.968-.541-2.357-1.342a1.9 1.9 0 01-.183-.817z"
      stroke="#979797"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
